import styles from "./ColorBox.module.scss";
import React, {useCallback} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";

export const DEFAULT_COLOR = "#555555|#FFFFFF";

const ColorBox = ({value, onChange}) => {
  const {t} = useTranslation("app");

  const [background, color] = (value || DEFAULT_COLOR).split("|");

  const selectColor = useCallback(preset => () => {
    onChange(preset.background + "|" + preset.color);
  }, [onChange]);

  const updateBackground = e => {
    if (!/^#[0-9ABCDEFabcdef]{0,6}$/.test(e.target.value)) {
      return;
    }

    onChange(e.target.value + "|" + color);
  };

  const updateColor = e => {
    if (!/^#[0-9ABCDEFabcdef]{0,6}$/.test(e.target.value)) {
      return;
    }

    onChange(background + "|" + e.target.value);
  };

  return (
    <div className={styles.colorBox}>
      <div className={styles.selection}>
        <div className={styles.preview}>
          <div style={{background, color}}>A</div>
        </div>
        <div className={styles.background}>
          <label>{t("colorbox_background_color")}</label>
          <Form.Control type="text" value={background} onChange={updateBackground}/>
        </div>
        <div className={styles.foreground}>
          <label>{t("colorbox_text_color")}</label>
          <Form.Control type="text" value={color} onChange={updateColor}/>
        </div>
      </div>

      <div className={styles.presets}>
        {presets.map(preset =>
          <div key={preset.background + preset.color}
               className={styles.colorBoxItem}
               style={{background: preset.background, color: preset.color}}
               onClick={selectColor(preset)}
          >A</div>)}
      </div>
    </div>
  );
};

const presets = [
  {background: "#f6c5be", color: "#822111"},
  {background: "#ffe6c7", color: "#a46a21"},
  {background: "#fef1d1", color: "#aa8831"},
  {background: "#b9e4d0", color: "#076239"},
  {background: "#c6f3de", color: "#1a764d"},
  {background: "#c9daf8", color: "#1c4587"},
  {background: "#e4d7f5", color: "#41236d"},
  {background: "#fcdee8", color: "#83334c"},
  {background: "#eeeeee", color: "#333333"},
  {background: "#efa093", color: "#822111"},
  {background: "#ffd6a2", color: "#a46a21"},
  {background: "#fce8b3", color: "#aa8831"},
  {background: "#89d3b2", color: "#076239"},
  {background: "#a0eac9", color: "#1a764d"},
  {background: "#a4c2f4", color: "#1c4587"},
  {background: "#d0bcf1", color: "#41236d"},
  {background: "#fbc8d9", color: "#83334c"},
  {background: "#cccccc", color: "#333333"},
  {background: "#e66550", color: "#822111"},
  {background: "#ffbc6b", color: "#a46a21"},
  {background: "#fcda83", color: "#aa8831"},
  {background: "#44b984", color: "#076239"},
  {background: "#68dfa9", color: "#1a764d"},
  {background: "#6d9eeb", color: "#1c4587"},
  {background: "#b694e8", color: "#41236d"},
  {background: "#f7a7c0", color: "#83334c"},
  {background: "#aaaaaa", color: "#333333"},
  {background: "#cc3a21", color: "#f6c5be"},
  {background: "#eaa041", color: "#ffe6c7"},
  {background: "#f2c960", color: "#fef1d1"},
  {background: "#149e60", color: "#b9e4d0"},
  {background: "#3dc789", color: "#c6f3de"},
  {background: "#3c78d8", color: "#c9daf8"},
  {background: "#8e63ce", color: "#e4d7f5"},
  {background: "#e07798", color: "#fcdee8"},
  {background: "#888888", color: "#ffffff"},
  {background: "#ac2b16", color: "#f6c5be"},
  {background: "#cf8933", color: "#ffe6c7"},
  {background: "#d5ae49", color: "#fef1d1"},
  {background: "#0b804b", color: "#b9e4d0"},
  {background: "#2a9c68", color: "#c6f3de"},
  {background: "#285bac", color: "#c9daf8"},
  {background: "#653e9b", color: "#e4d7f5"},
  {background: "#b65775", color: "#fcdee8"},
  {background: "#555555", color: "#FFFFFF"},
  {background: "#822111", color: "#f6c5be"},
  {background: "#a46a21", color: "#ffe6c7"},
  {background: "#aa8831", color: "#fef1d1"},
  {background: "#076239", color: "#b9e4d0"},
  {background: "#1a764d", color: "#c6f3de"},
  {background: "#1c4587", color: "#c9daf8"},
  {background: "#41236d", color: "#e4d7f5"},
  {background: "#83334c", color: "#fcdee8"},
  {background: "#333333", color: "#FFFFFF"}
];

export default ColorBox;
